import React, { useEffect, useMemo } from "react";
import { buildB2BDocumentHtml } from "../../data/b2bDocuments";

export default function FactureViewModal({ sale, client, onClose }) {
  const srcDoc = useMemo(
    () => buildB2BDocumentHtml(sale || {}, client || {}, null),
    [sale, client]
  );

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!sale) return null;

  const isDevis = sale.documentType === "devis";

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.75)", zIndex: 1080 }} onClick={onClose}>
      <div className="modal-dialog modal-xl modal-dialog-centered" style={{ maxWidth: "1000px" }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-content border-0 shadow-lg">
          <div className="modal-header">
            <h5 className="modal-title">
              {isDevis ? "Devis" : "Facture"}{" "}
              {sale.documentNumber ? <span className="text-muted">— {sale.documentNumber}</span> : <span className="badge bg-warning text-dark ms-2">BROUILLON</span>}
            </h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body p-0">
            <iframe title="Aperçu du document" srcDoc={srcDoc} style={{ width: "100%", height: "70vh", border: "none" }} />
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Fermer</button>
          </div>
        </div>
      </div>
    </div>
  );
}
